<mat-card (click)="onActiviteitCardClick()">
  <mat-card-header>
    <div mat-card-avatar>
      <zah-icon-avatar [icon]="activiteit.getType() | zahActiviteitTypeIcon">
      </zah-icon-avatar>
    </div>
    <mat-card-title>{{ activiteit.getType() | zahActiviteitType }}</mat-card-title>
    <mat-card-subtitle>
      <span>{{ activiteit.getTimestamp() | date: 'd MMMM yyyy HH:mm' }}</span>
    </mat-card-subtitle>
  </mat-card-header>

  <div class="person">
    <mat-icon>face</mat-icon>
    <div class="details">
      <div>{{ client.getNaam() }}</div>
      <div class="mat-small">{{ client.getNummer() }} - {{ getZoneIdsToDisplay() | zahZones:zones}}</div>
    </div>
  </div>

  <div class="person">
    <mat-icon>{{ auteur.getFirstRole() | zahRolIcon }}</mat-icon>
    <div class="details">
      <div [class.deleted-user]="auteur.isVerwijderd()">{{ auteur.getNaam() }}</div>
      <div class="mat-small">{{ auteur.getPersoneelsnummer() }} - {{ auteur.getFirstRole() }}</div>
    </div>
  </div>

  <mat-card-content>
    <div>
      <span>{{ activiteit.getContent() }}</span>
      @if (activiteit.isUpdate()) {
        <span class="wijziging mat-small"> (wijziging)</span>
      }
    </div>
  </mat-card-content>

  @if (!activiteit.isVerwerkt()) {
    <mat-card-actions
      align="end">
      <button mat-flat-button
        color="primary"
        (click)="onVerwerkClicked()">
        Gelezen
      </button>
    </mat-card-actions>
  }
</mat-card>
